module.exports = __webpack_public_path__ + "static/media/video.f931e8c5.mp4";